import { useQuery } from '@tanstack/react-query';
import getAxios from 'apiRestConnector';
import { SkillsInterface } from 'components/models/SkillsInterfaces';
import { DatosInterface } from 'components/models/PersonalInformationInterfaces';

// Interfaz específica para la respuesta de la vista pública
interface PublicCandidate {
  nombre: string;
  telefono: string; // Puede venir formateado/oculto
  datos: DatosInterface[]; // Datos públicos filtrados
  skills: SkillsInterface[]; // Filtrado si aplica
  competencias: any[]; // Filtrado
  footer: any[]; // Filtrado si aplica
  profileImgUrl?: string;
  // Nuevos campos esperados como top-level
  tarifa?: number; 
  monedaTarifa?: string;
  // Otros campos públicos que devuelva la API...
}

export const usePublicView = (hashCandidate: string) => {

  // Usar una instancia sin token si la vista pública no requiere autenticación
  const axiosInstance = getAxios.instance(); // Asumiendo que no requiere token

  const candidateQuery = useQuery<PublicCandidate>({ // Usar la interfaz específica
    queryKey: ['publicCandidateView', hashCandidate], // Usar queryKey diferente
    queryFn: async () => {
      // Asumiendo que la API pública es accesible sin token
      const { data } = await axiosInstance.get(`/personas/public/view/${hashCandidate}`);
      
      // Extraer Tarifa y Moneda del array 'datos'
      let tarifaValue: number | undefined = undefined;
      let monedaTarifaValue: string | undefined = undefined;

      if (data.datos && Array.isArray(data.datos)) {
        const tarifaData = data.datos.find((d: DatosInterface) => d.nombre === 'Tarifa');
        if (tarifaData && (typeof tarifaData.valor === 'number' || typeof tarifaData.valor === 'string')) {
          const num = Number(tarifaData.valor); // Intentar convertir por si viene como string
          if (!isNaN(num)) {
            tarifaValue = num;
          } else {
            console.warn('Valor de Tarifa no es un número válido:', tarifaData.valor);
          }
        }

        const monedaTarifaData = data.datos.find((d: DatosInterface) => d.nombre === 'Moneda Tarifa');
        if (monedaTarifaData && typeof monedaTarifaData.valor === 'string') {
          monedaTarifaValue = monedaTarifaData.valor;
        }
      }

      // Construir el objeto PublicCandidate con los datos extraídos
      return { 
        nombre: data.nombre,
        telefono: data.telefono,
        datos: data.datos, // Devolver el array datos filtrado como viene de la API
        skills: data.skills,
        competencias: data.competencias,
        footer: data.footer,
        profileImgUrl: data.profileImgUrl,
        // Asignar los valores extraídos a los campos de primer nivel
        tarifa: tarifaValue, 
        monedaTarifa: monedaTarifaValue,
        // Incluir otros campos raíz que la API pueda devolver y estén en PublicCandidate
      } as PublicCandidate;
    },
    enabled: !!hashCandidate, // Solo ejecutar si hashCandidate existe
    staleTime: 0, // Cache por 0 minutos
  });

  return {
    candidate: candidateQuery.data,
    isLoading: candidateQuery.isLoading,
    error: candidateQuery.error
  };
}; 